export default __webpack_public_path__ + "./images/ps.3cebd351.png";